import "./Header.scss";
import { useState } from "react";

const Header = () => {
  const [isCollapsedNavbarOpen, setCollapsedNavbarOpen] = useState<boolean>(false);

  return (
    <div className="header-container">
      <nav className="navbar navbar-expand-md navbar-light p-0">
        <div className="container-fluid" style={{ paddingTop: "16px" }}>
          <div>
            <a className="navbar-brand align-middle p-0" href={(window as any).siteRootUrl} aria-label="incoin.biz site">
              <img src="/img/incoin_logo_new.svg" width="119" height="45" alt="incoin.biz logo"></img>
            </a>
            {(window as any).useTestNet && <div className="badge bg-danger align-top">TESTNET</div>}
            {(window as any).environmentName !== "LIVE" && <div className="badge bg-danger align-top ms-1">{(window as any).environmentName}</div>}
          </div>

          <>
            <button
              className="navbar-toggler text-white"
              type="button"
              onClick={() => setCollapsedNavbarOpen(!isCollapsedNavbarOpen)}
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className={"collapse navbar-collapse" + (isCollapsedNavbarOpen ? " show" : "")}
              id="navbarNav"
              style={{ zIndex: 2, backgroundColor: "white", paddingTop: "15px" }}
            >
              <ul className="navbar-nav ms-auto">
                <li className="nav-item mb-2 pe-0 pe-md-1">
                  <a className="nav-link nav-link-top" target="_blank" rel="noreferrer" href={(window as any).siteRootUrl + "/posts"}>
                    blog
                  </a>
                </li>
                <li className="nav-item mb-2 pe-0 pe-md-1">
                  <a className="nav-link nav-link-top" target="_blank" rel="noreferrer" href={(window as any).siteRootUrl + "/developer"}>
                    developer
                  </a>
                </li>
                <li className="nav-item mb-2 pe-0 pe-md-1">
                  <a className="nav-link nav-link-top" target="_blank" rel="noreferrer" href={(window as any).siteRootUrl + "/help"}>
                    help
                  </a>
                </li>
                <li className="nav-item mb-2 pe-0 pe-md-1">
                  <a className="nav-link nav-link-top" target="_blank" rel="noreferrer" href={(window as any).siteRootUrl + "/plugin"}>
                    plugin
                  </a>
                </li>
              </ul>
            </div>
          </>
        </div>
      </nav>
    </div>
  );
};

export default Header;
